import { useState, useEffect } from "react";
import { supabase } from "../supabase";
import { C } from "../lib/constants";
import { normalizeMode } from "../lib/helpers";
import { Btn } from "./ui/Btn";
import { TopNav } from "./ui/TopNav";
import { Chip } from "./ui/Chip";
export const ObraActiva = ({setScreen, user, profile, activeMode, setActiveMode}) => {

  // ── Todos los hooks al inicio ──────────────────────────────────────────────
  const [obraStatus,     setObraStatus]     = useState("sin_solicitud");
  const [showDisputa,    setShowDisputa]     = useState(false);
  const [confirmClose,   setConfirmClose]   = useState(false);
  const [geoShared,      setGeoShared]      = useState(false);
  const [geoLoading,     setGeoLoading]     = useState(false);
  const [clienteVerif,   setClienteVerif]   = useState(false);
  const [verCodigo,      setVerCodigo]      = useState("");
  const [codigoEnv,      setCodigoEnv]      = useState(false);
  const [tiempoEst,      setTiempoEst]      = useState("");
  const [showProrroga,   setShowProrroga]   = useState(false);
  const [prorrogaMotivo, setProrrogaMotivo] = useState("");
  const [countdown,      setCountdown]      = useState("");
  const [solCliente,     setSolCliente]     = useState(null);
  const [solTrabajador,  setSolTrabajador]  = useState(null);
  const [cargando,       setCargando]       = useState(true);
  const [rolDetectado,   setRolDetectado]   = useState(null);
  const [vistaActiva,    setVistaActiva]    = useState(null);

  const nombreUsuario   = profile?.nombre || user?.email || "";
  const telefonoUsuario = profile?.telefono || "";

  // ── Carga inteligente ─────────────────────────────────────────────────────
  useEffect(() => {
    if (!user?.id) { setCargando(false); return; }
    let alive = true;
    const cargar = async () => {
      try {
        // FICIO SEGURIDAD: verificar sesión activa antes de cualquier query
        const { data: authCheck } = await supabase.auth.getUser();
        if (!authCheck?.user?.id || authCheck.user.id !== user.id) {
          console.warn("FICIO ObraActiva: sesión no coincide");
          if (alive) setCargando(false);
          return;
        }
        const currentUserId = authCheck.user.id;

        const [resC, resT] = await Promise.all([
          supabase.from("solicitudes")
            .select("*")
            .eq("cliente_user_id", currentUserId)
            .in("estado", ["pendiente","aceptada","en_progreso"])
            .order("created_at", {ascending:false})
            .limit(1)
            .maybeSingle(),
          supabase.from("solicitudes")
            .select("*")
            .eq("trabajador_user_id", currentUserId)
            .in("estado", ["pendiente","aceptada","en_progreso"])
            .order("created_at", {ascending:false})
            .limit(1)
            .maybeSingle(),
        ]);

        if (!alive) return;
        const sc = resC.data || null;
        const st = resT.data || null;
        setSolCliente(sc);
        setSolTrabajador(st);

        if (sc && st) {
          setRolDetectado("ambos");
          setVistaActiva(prev => prev || "trabajador");
        } else if (st) {
          setRolDetectado("trabajador");
          setVistaActiva("trabajador");
          setActiveMode?.("trabajador", currentUserId);
        } else if (sc) {
          setRolDetectado("cliente");
          setVistaActiva("cliente");
          setActiveMode?.("cliente", currentUserId);
        } else {
          setRolDetectado(null);
          setVistaActiva(normalizeMode(activeMode) || "cliente");
        }
      } catch(e) {
        console.warn("ObraActiva:", e.message);
      } finally {
        if (alive) setCargando(false);
      }
    };
    cargar();
    const channel = supabase.channel(`obra-activa-${user.id}`)
      .on("postgres_changes",{event:"*",schema:"public",table:"solicitudes"},cargar).subscribe();
    return () => { alive = false; supabase.removeChannel(channel); };
  }, [user?.id]); // eslint-disable-line

  const solicitudActiva = vistaActiva === "trabajador" ? solTrabajador : solCliente;
  const role = vistaActiva || "cliente";

  useEffect(() => {
    if (!solicitudActiva) { setObraStatus("sin_solicitud"); return; }
    const m = {
      pendiente:   "esperando_trabajador",
      aceptada:    "confirmada_trabajador",
      en_progreso: "activa",
      completada:  "cerrada",
      cancelada:   "cerrada",
    };
    setObraStatus(m[solicitudActiva.estado] || "sin_solicitud");
  }, [solicitudActiva, vistaActiva]);

  useEffect(() => {
    if (!solicitudActiva?.created_at || obraStatus !== "esperando_trabajador") { setCountdown(""); return; }
    const expira = new Date(solicitudActiva.created_at).getTime() + 2*60*60*1000;
    const tick = () => {
      const diff = expira - Date.now();
      if (diff <= 0) { setCountdown("Expirada"); return; }
      const h=Math.floor(diff/3600000), m=Math.floor((diff%3600000)/60000), s=Math.floor((diff%60000)/1000);
      setCountdown(`${h}:${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`);
    };
    tick(); const iv=setInterval(tick,1000); return ()=>clearInterval(iv);
  }, [solicitudActiva?.created_at, obraStatus]);

  const cambiarModoObra = (nuevoModo) => {
    const modo = normalizeMode(nuevoModo);
    setVistaActiva(modo);
    setActiveMode?.(modo, user?.id || null);
    if (user?.id) {
      supabase.from("perfiles")
        .upsert({user_id:user.id,modo_activo:modo,updated_at:new Date().toISOString()},{onConflict:"user_id"})
        .then(({error})=>{if(error)console.warn("modo:",error.message)}).catch(console.warn);
    }
  };

  const TIEMPOS = [
    {val:"1d",   label:"1 día",     cobertura:"1 día",    icon:"⚡"},
    {val:"2-3d", label:"2–3 días",  cobertura:"3 días",   icon:"📅"},
    {val:"1s",   label:"1 semana",  cobertura:"7 días",   icon:"🗓️"},
    {val:"2s",   label:"2 semanas", cobertura:"14 días",  icon:"📆"},
    {val:"1m",   label:"1 mes",     cobertura:"30 días",  icon:"🏗️"},
  ];

  const OBRA = solicitudActiva ? {
    trabajador: solicitudActiva.trabajador_nombre || "Trabajador",
    trade:      solicitudActiva.trabajador_oficio || solicitudActiva.oficio || "Oficio",
    cliente:    solicitudActiva.cliente_nombre    || nombreUsuario,
    descripcion:solicitudActiva.descripcion       || "Sin descripción",
    direccion:  solicitudActiva.zona              || solicitudActiva.trabajador_zona || "Sin dirección",
    folio:      `FIC-${String(solicitudActiva.id||"").slice(0,8).toUpperCase()}`,
    solicitudId:solicitudActiva.id,
  } : {trabajador:"—",trade:"—",cliente:nombreUsuario,descripcion:"—",direccion:"—",folio:"—",solicitudId:null};

  const actualizarStatusSolicitud = async (nuevoEstado, extra={}) => {
    if (!solicitudActiva?.id) return;
    const {error} = await supabase.from("solicitudes")
      .update({estado:nuevoEstado,updated_at:new Date().toISOString(),...extra})
      .eq("id",solicitudActiva.id);
    if (error) console.warn("Error actualizando solicitud:", error.message);
  };

  const simularGeo = () => {
    if (!navigator.geolocation) { window.ficioToast?.("Tu navegador no soporta geolocalización", "warn"); return; }
    setGeoLoading(true);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        setGeoShared(true); setGeoLoading(false);
        if (solicitudActiva?.id) {
          await supabase.from("solicitudes").update({
            geo_lat:pos.coords.latitude, geo_lng:pos.coords.longitude,
            geo_at:new Date().toISOString(), updated_at:new Date().toISOString()
          }).eq("id",solicitudActiva.id);
        }
      },
      (err) => { console.warn("Geo:",err.message); setGeoShared("omitida"); window.ficioToast?.("Geolocalización no disponible. Puedes continuar sin ella.", "warn"); setGeoLoading(false); },
      {timeout:10000,enableHighAccuracy:true}
    );
  };

  const ST = {
    sin_solicitud:        {label:"Sin obra activa",                    color:C.muted,  icon:"⏸️",bg:C.faint  },
    esperando_trabajador: {label:"Esperando confirmación del maestro", color:C.accent, icon:"⏳",bg:C.accentL},
    confirmada_trabajador:{label:"Maestro confirmó · Esperando inicio",color:C.blue,   icon:"✓", bg:C.blueL  },
    activa:               {label:"Obra activa · Cobertura vigente",    color:C.green,  icon:"🟢",bg:C.greenL },
    disputa:              {label:"En revisión · Mediador asignado",    color:C.blue,   icon:"⚖️",bg:C.blueL  },
    cerrada:              {label:"Obra cerrada · Cobertura terminada", color:C.sub,    icon:"✅",bg:C.divider },
  };
  const st = ST[obraStatus] || ST.sin_solicitud;

  // ── Sin sesión ─────────────────────────────────────────────────────────────
  if (!user) return (
    <div style={{minHeight:"100vh",background:C.bg,paddingBottom:100}}>
      <TopNav setScreen={setScreen} back="landing" backLabel="Inicio" title="Mi Obra"/>
      <div style={{maxWidth:480,margin:"0 auto",padding:"40px 20px",textAlign:"center"}}>
        <div style={{fontSize:52,marginBottom:12}}>🔐</div>
        <div style={{fontFamily:"Georgia,serif",fontSize:22,fontWeight:800,color:C.text,marginBottom:8}}>Inicia sesión</div>
        <div style={{color:C.sub,fontSize:13,marginBottom:20}}>Para ver tu obra activa necesitas entrar a tu cuenta.</div>
        <Btn full color={C.accent} onClick={()=>setScreen("cliente-login")}>Iniciar sesión</Btn>
      </div>
    </div>
  );

  // ── Cargando ──────────────────────────────────────────────────────────────
  if (cargando) return (
    <div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{textAlign:"center",color:C.muted}}>
        <div style={{fontSize:36,marginBottom:8}}>⏳</div>
        <div style={{fontSize:14}}>Buscando tu obra...</div>
      </div>
    </div>
  );

  // ── Sin actividad — pantalla de inicio ────────────────────────────────────
  if (!rolDetectado && obraStatus === "sin_solicitud") return (
    <div style={{minHeight:"100vh",background:C.bg,paddingBottom:100}}>
      <TopNav setScreen={setScreen} back="landing" backLabel="Inicio" title="Mi Obra"/>
      <div style={{maxWidth:520,margin:"0 auto",padding:"32px 20px"}}>
        <div style={{textAlign:"center",marginBottom:28}}>
          <div style={{fontSize:56,marginBottom:10}}>🏗️</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:24,fontWeight:800,color:C.text,marginBottom:6}}>
            Hola, {nombreUsuario.split(" ")[0]}
          </div>
          <div style={{color:C.muted,fontSize:14}}>No tienes ninguna obra activa.</div>
        </div>

        <div style={{fontFamily:"Georgia,serif",fontSize:16,fontWeight:800,color:C.text,marginBottom:12,textAlign:"center"}}>¿Qué quieres hacer hoy?</div>

        <div style={{display:"flex",flexDirection:"column",gap:12,marginBottom:24}}>
          {[
            {icon:"🔍",title:"Contratar un maestro",desc:"Busca en el directorio y solicita cotización.",color:C.blue,action:()=>setScreen("directory")},
            // FIX: si activeMode es trabajador, ir a solicitudes en lugar de registro
            {icon:"🔨",title:normalizeMode(activeMode)==="trabajador"?"Ver mis solicitudes":"Ofrecer mis servicios",
             desc:normalizeMode(activeMode)==="trabajador"?"Revisa las solicitudes que te llegaron.":"Regístrate como maestro y aparece en Ficio.",
             color:C.accent,
             action:()=>setScreen(normalizeMode(activeMode)==="trabajador" ? "solicitudes-worker" : "reg-worker")},
          ].map(item=>(
            <div key={item.title} onClick={item.action}
              style={{background:C.surface,border:`1.5px solid ${item.color}25`,borderRadius:18,padding:"20px",cursor:"pointer",display:"flex",gap:16,alignItems:"center",boxShadow:"0 2px 8px rgba(0,0,0,0.04)"}}>
              <div style={{width:52,height:52,borderRadius:16,background:`${item.color}15`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:26,flexShrink:0}}>{item.icon}</div>
              <div style={{flex:1}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:17,fontWeight:800,color:C.text,marginBottom:3}}>{item.title}</div>
                <div style={{color:C.muted,fontSize:12}}>{item.desc}</div>
              </div>
              <div style={{color:item.color,fontSize:20}}>›</div>
            </div>
          ))}
        </div>

        <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:14,padding:16}}>
          <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:12}}>¿Cómo funciona Ficio?</div>
          {[
            {n:"1",color:C.blue,   text:"Cliente encuentra al maestro y solicita cotización"},
            {n:"2",color:C.accent, text:"Maestro confirma disponibilidad y acepta el trabajo"},
            {n:"3",color:C.green,  text:"Cliente autoriza y la obra queda activa con cobertura"},
            {n:"4",color:"#7B5EA7",text:"Al terminar, cliente califica con reseña verificada"},
          ].map(s=>(
            <div key={s.n} style={{display:"flex",gap:10,marginBottom:8,alignItems:"flex-start"}}>
              <div style={{width:22,height:22,borderRadius:"50%",background:`${s.color}15`,border:`1.5px solid ${s.color}40`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                <span style={{color:s.color,fontSize:11,fontWeight:800}}>{s.n}</span>
              </div>
              <span style={{color:C.sub,fontSize:12,lineHeight:1.5,marginTop:2}}>{s.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh",background:C.bg,paddingBottom:100}}>
      <TopNav setScreen={setScreen} back="landing" backLabel="Inicio"
        title={role==="trabajador" ? "Mis trabajos" : "Mi obra activa"}/>
      <div style={{maxWidth:560,margin:"0 auto",padding:"24px 20px"}}>

        {/* Toggle discreto — SOLO si tiene ambos roles activos simultáneamente */}
        {rolDetectado==="ambos" && (
          <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:14,padding:"6px",marginBottom:14,display:"grid",gridTemplateColumns:"1fr 1fr",gap:4,boxShadow:"0 2px 6px rgba(0,0,0,.04)"}}>
            <button onClick={()=>cambiarModoObra("cliente")}
              style={{border:"none",borderRadius:10,padding:"10px",background:role==="cliente"?C.blue:"transparent",color:role==="cliente"?"#fff":C.sub,fontWeight:800,cursor:"pointer",fontSize:13,transition:"all 0.2s"}}>
              🏠 Como cliente
            </button>
            <button onClick={()=>cambiarModoObra("trabajador")}
              style={{border:"none",borderRadius:10,padding:"10px",background:role==="trabajador"?C.accent:"transparent",color:role==="trabajador"?"#fff":C.sub,fontWeight:800,cursor:"pointer",fontSize:13,transition:"all 0.2s"}}>
              🔨 Como maestro
            </button>
          </div>
        )}

        {/* Status badge */}
        <div style={{background:st.bg,border:`1.5px solid ${st.color}30`,borderRadius:14,padding:"14px 16px",marginBottom:16,display:"flex",alignItems:"center",gap:12}}>
          <span style={{fontSize:22}}>{st.icon}</span>
          <div>
            <div style={{color:st.color,fontWeight:700,fontSize:14,fontFamily:"'Georgia',serif"}}>{st.label}</div>
            {obraStatus==="activa"&&<div style={{color:C.sub,fontSize:12}}>Fondo activo · L-S 7am–6pm · Folio {OBRA.folio}</div>}
            {obraStatus==="esperando_trabajador"&&<div style={{color:C.sub,fontSize:12}}>El maestro tiene 2 horas para confirmar o la solicitud expira</div>}
            {obraStatus==="confirmada_trabajador"&&<div style={{color:C.sub,fontSize:12}}>El maestro aceptó · Confirma tú para activar la cobertura</div>}
          </div>
        </div>

        {/* Detalle de la obra */}
        <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:16,padding:18,marginBottom:16,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
          <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:12}}>Detalle de la obra</div>
          {[["👷 Trabajador",OBRA.trabajador],["📋 Trabajo",OBRA.descripcion],["📍 Dirección",OBRA.direccion],["🏗️ Folio",OBRA.folio],["👤 Cliente",OBRA.cliente]].map(([k,v])=>(
            <div key={k} style={{display:"flex",gap:12,marginBottom:8,paddingBottom:8,borderBottom:`1px solid ${C.divider}`}}>
              <span style={{color:C.muted,fontSize:12,minWidth:110}}>{k}</span>
              <span style={{color:C.text,fontSize:12,fontWeight:600,flex:1}}>{v}</span>
            </div>
          ))}
          {tiempoEst && (
            <div style={{display:"flex",gap:12,marginBottom:8,paddingBottom:8,borderBottom:`1px solid ${C.divider}`}}>
              <span style={{color:C.muted,fontSize:12,minWidth:110}}>⏱️ Tiempo estimado</span>
              <span style={{color:C.green,fontSize:12,fontWeight:700}}>{TIEMPOS.find(t=>t.val===tiempoEst)?.label} · Cobertura por {TIEMPOS.find(t=>t.val===tiempoEst)?.cobertura}</span>
            </div>
          )}
          {tiempoEst && obraStatus==="activa" && (
            <div style={{display:"flex",gap:12}}>
              <span style={{color:C.muted,fontSize:12,minWidth:110}}>🔄 Prórroga</span>
              <button onClick={()=>setShowProrroga(true)}
                style={{background:C.accentL,border:`1px solid ${C.accent}30`,borderRadius:8,padding:"4px 12px",color:C.accent,fontSize:11,fontWeight:700,cursor:"pointer"}}>
                Solicitar prórroga →
              </button>
            </div>
          )}
        </div>

        {/* ══ FLUJO CLIENTE ══════════════════════════════════════════════════ */}
        {role==="cliente" && (
          <div>

            {/* PASO 1 — Verificación de identidad */}
            {obraStatus==="sin_solicitud" && !clienteVerif && (
              <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:16,padding:18,marginBottom:14,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
                <div style={{fontFamily:"'Georgia',serif",fontSize:16,fontWeight:800,color:C.text,marginBottom:4}}>Paso 1 — Verifica tu identidad</div>
                <div style={{color:C.muted,fontSize:12,lineHeight:1.6,marginBottom:16}}>Solo clientes verificados pueden activar una obra. Esto protege al trabajador de solicitudes falsas.</div>
                <div style={{background:C.blueL,border:`1px solid ${C.blue}25`,borderRadius:12,padding:"12px 14px",marginBottom:14}}>
                  <div style={{color:C.blue,fontWeight:700,fontSize:12,marginBottom:2}}>📱 Verificación por SMS</div>
                  <div style={{color:C.sub,fontSize:12}}>Te enviamos un código de 6 dígitos a tu número registrado en Ficio.</div>
                </div>
                {!codigoEnv ? (
                  <Btn full color={C.blue} onClick={()=>setCodigoEnv(true)}>Enviar código de verificación</Btn>
                ) : (
                  <div>
                    <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:8}}>Código recibido por SMS</div>
                    <div style={{display:"flex",gap:8,marginBottom:12}}>
                      <input value={verCodigo} onChange={e=>setVerCodigo(e.target.value)} placeholder="123456" maxLength={6}
                        style={{flex:1,background:C.bg,border:`1.5px solid ${verCodigo.length===6?C.green:C.border}`,borderRadius:12,padding:"13px 16px",color:C.text,fontSize:18,letterSpacing:8,outline:"none",textAlign:"center",fontFamily:"'Georgia',serif",fontWeight:800}}/>
                      <Btn color={C.green} onClick={()=>{if(verCodigo.length===6)setClienteVerif(true);}}>Verificar</Btn>
                    </div>
                    <div style={{color:C.muted,fontSize:11,textAlign:"center"}}>Para este demo usa cualquier código de 6 dígitos</div>
                  </div>
                )}
              </div>
            )}

            {/* PASO 2 — Solicitar obra (cliente verificado) */}
            {obraStatus==="sin_solicitud" && clienteVerif && (
              <div>
                <div style={{background:C.greenL,border:`1.5px solid ${C.green}30`,borderRadius:12,padding:"12px 14px",marginBottom:14,display:"flex",gap:8,alignItems:"center"}}>
                  <span style={{fontSize:18}}>✅</span>
                  <div>
                    <div style={{color:C.green,fontWeight:700,fontSize:12}}>Identidad verificada</div>
                    <div style={{color:C.sub,fontSize:11}}>{nombreUsuario} · {telefonoUsuario || "teléfono registrado"} · Ficio ID verificado</div>
                  </div>
                </div>
                <div style={{background:"#FFFDE7",border:`1px solid #F9A82540`,borderRadius:12,padding:"12px 14px",marginBottom:14}}>
                  <div style={{color:"#795548",fontWeight:700,fontSize:12,marginBottom:4}}>⚠️ Importante antes de solicitar</div>
                  {["El trabajador debe confirmar que sí está trabajando contigo — no puedes activar la obra sin su confirmación.","Si el trabajador no confirma en 2 horas la solicitud expira automáticamente.","La cobertura del Fondo Ficio inicia solo cuando ambos confirman."].map((r,i)=>(
                    <div key={i} style={{display:"flex",gap:6,marginBottom:5}}><span style={{color:"#F57F17",fontWeight:700}}>·</span><span style={{color:"#795548",fontSize:12}}>{r}</span></div>
                  ))}
                </div>
                {solicitudActiva ? (
                  <div style={{background:C.greenL,border:`1.5px solid ${C.green}30`,borderRadius:12,padding:"12px 14px",marginTop:8}}>
                    <div style={{color:C.green,fontWeight:700,fontSize:12,marginBottom:2}}>✅ Solicitud enviada</div>
                    <div style={{color:C.sub,fontSize:12}}>Tu solicitud ya fue enviada a <strong>{solicitudActiva.trabajador_nombre || "el trabajador"}</strong>. Esperando su confirmación.</div>
                  </div>
                ) : (
                  <Btn full color={C.green} onClick={()=>setScreen("directory")}>
                    🔍 Buscar un maestro para solicitar obra
                  </Btn>
                )}
              </div>
            )}

            {/* PASO 3 — Esperando al trabajador */}
            {obraStatus==="esperando_trabajador" && (
              <div>
                <div style={{background:C.accentL,border:`1.5px solid ${C.accent}30`,borderRadius:14,padding:16,marginBottom:14}}>
                  <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:10}}>
                    <span style={{fontSize:24}}>⏳</span>
                    <div>
                      <div style={{color:C.accent,fontWeight:700,fontSize:14}}>Solicitud enviada al maestro</div>
                      <div style={{color:C.sub,fontSize:12}}>Tiene 2 horas para confirmar</div>
                    </div>
                  </div>
                  <div style={{background:"rgba(255,255,255,0.6)",borderRadius:10,padding:"10px 12px"}}>
                    <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:C.sub}}>
                      <span>Tiempo restante</span>
                      <span style={{color:countdown==="Expirada"?C.red:C.accent,fontWeight:700}}>{countdown || "Calculando..."}</span>
                    </div>
                    <div style={{background:C.border,borderRadius:4,height:4,marginTop:6}}>
                      <div style={{background:C.accent,height:4,borderRadius:4,width:"89%"}}/>
                    </div>
                  </div>
                </div>
                <div style={{display:"flex",gap:10}}>
                  <Btn full outline color={C.red} onClick={async()=>{
                    await actualizarStatusSolicitud("cancelada",{cliente_concluyo:false});
                    setObraStatus("sin_solicitud");
                  }}>Cancelar solicitud</Btn>
                </div>
              </div>
            )}

            {/* PASO 4 — Trabajador confirmó, cliente activa */}
            {obraStatus==="confirmada_trabajador" && (
              <div>
                <div style={{background:C.blueL,border:`1.5px solid ${C.blue}30`,borderRadius:14,padding:16,marginBottom:14}}>
                  <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:10}}>
                    <span style={{fontSize:24}}>✅</span>
                    <div>
                      <div style={{color:C.blue,fontWeight:700,fontSize:14}}>{OBRA.trabajador.split(" ")[0]} confirmó la obra</div>
                      <div style={{color:C.sub,fontSize:12}}>Ahora tú activas la cobertura del fondo</div>
                    </div>
                  </div>
                  <div style={{background:"rgba(255,255,255,0.7)",borderRadius:10,padding:"10px 12px"}}>
                    <div style={{color:C.blue,fontSize:12,fontWeight:600,marginBottom:3}}>El maestro confirmó que:</div>
                    {["Está físicamente en la dirección indicada","Trabajará contigo en la obra descrita","Acepta quedar cubierto por el Fondo Ficio"].map((r,i)=>(
                      <div key={i} style={{display:"flex",gap:6,marginBottom:4}}><span style={{color:C.green,fontWeight:700}}>✓</span><span style={{color:C.sub,fontSize:12}}>{r}</span></div>
                    ))}
                  </div>
                </div>
                <div style={{background:C.greenL,border:`1.5px solid ${C.green}30`,borderRadius:12,padding:"12px 14px",marginBottom:14}}>
                  <div style={{color:C.green,fontWeight:700,fontSize:12,marginBottom:3}}>🛡️ Al confirmar tú también</div>
                  <div style={{color:C.sub,fontSize:12}}>La cobertura del Fondo Ficio queda activa para este trabajador. Ambos están protegidos.</div>
                </div>
                <Btn full color={C.green} onClick={async ()=>{
                  await actualizarStatusSolicitud("en_progreso", { cliente_autorizo: true, started_at: new Date().toISOString() });
                  setObraStatus("activa");
                }}>▶ Confirmar y activar cobertura</Btn>
              </div>
            )}

            {/* Obra activa */}
            {obraStatus==="activa" && (
              <div>
                <div style={{background:C.greenL,border:`1.5px solid ${C.green}30`,borderRadius:12,padding:"14px 16px",marginBottom:14}}>
                  <div style={{color:C.green,fontWeight:700,fontSize:13,marginBottom:4}}>🟢 Cobertura activa</div>
                  <div style={{color:C.sub,fontSize:12}}>El Fondo Ficio respalda a {OBRA.trabajador.split(" ")[0]} mientras trabaja. L-S 7am–6pm.</div>
                </div>
                {!confirmClose ? (
                  <Btn full outline color={C.red} onClick={()=>setConfirmClose(true)}>⏹ Cerrar obra</Btn>
                ) : (
                  <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:16,padding:18,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
                    <div style={{fontFamily:"'Georgia',serif",fontSize:17,fontWeight:800,color:C.text,marginBottom:6}}>¿Confirmas cerrar la obra?</div>
                    <div style={{color:C.muted,fontSize:13,marginBottom:16}}>La cobertura termina y podrás calificar el trabajo.</div>
                    <div style={{display:"flex",gap:10}}>
                      <Btn full outline color={C.muted} onClick={()=>setConfirmClose(false)}>Cancelar</Btn>
                      <Btn full color={C.green} onClick={async ()=>{
                        await actualizarStatusSolicitud("completada", { cliente_concluyo: true, finished_at: new Date().toISOString() });
                        setObraStatus("cerrada");
                        setConfirmClose(false);
                      }}>Sí, cerrar obra</Btn>
                    </div>
                  </div>
                )}
              </div>
            )}

            {obraStatus==="disputa"&&<div style={{background:C.blueL,border:`1.5px solid ${C.blue}30`,borderRadius:12,padding:"14px 16px"}}><div style={{color:C.blue,fontWeight:700,fontSize:13,marginBottom:4}}>⚖️ Caso en mediación</div><div style={{color:C.sub,fontSize:12}}>Resolución en 48 horas.</div></div>}
            {obraStatus==="cerrada"&&<div style={{background:C.greenL,border:`1.5px solid ${C.green}30`,borderRadius:12,padding:"14px 16px"}}><div style={{color:C.green,fontWeight:700,fontSize:13,marginBottom:4}}>✅ Obra cerrada</div><div style={{color:C.sub,fontSize:12}}>Ya puedes calificar el trabajo.</div></div>}
          </div>
        )}

        {/* ══ FLUJO TRABAJADOR ═══════════════════════════════════════════════ */}
        {role==="trabajador" && (
          <div>

            {/* Sin solicitud */}
            {obraStatus==="sin_solicitud" && (
              <div style={{background:C.faint,border:`1px solid ${C.border}`,borderRadius:14,padding:18,textAlign:"center"}}>
                <div style={{fontSize:40,marginBottom:10}}>⏸️</div>
                <div style={{fontFamily:"'Georgia',serif",fontSize:16,fontWeight:800,color:C.text,marginBottom:4}}>Sin obra activa</div>
                <div style={{color:C.muted,fontSize:13}}>Cuando un cliente solicite activar una obra contigo recibirás una notificación aquí y por WhatsApp.</div>
              </div>
            )}

            {/* SOLICITUD RECIBIDA — el trabajador confirma */}
            {obraStatus==="esperando_trabajador" && (
              <div>
                <div style={{background:`linear-gradient(135deg,${C.accent},${C.accentD})`,borderRadius:16,padding:18,marginBottom:14,boxShadow:`0 4px 16px ${C.accent}40`}}>
                  <div style={{display:"flex",gap:10,alignItems:"flex-start",marginBottom:14}}>
                    <span style={{fontSize:26}}>🔔</span>
                    <div>
                      <div style={{color:"#fff",fontWeight:700,fontSize:16,marginBottom:3}}>Solicitud de obra recibida</div>
                      <div style={{color:"rgba(255,255,255,0.85)",fontSize:13}}>{solicitudActiva?.cliente_nombre || "Cliente"} quiere activar una obra contigo</div>
                    </div>
                  </div>
                  <div style={{background:"rgba(255,255,255,0.15)",borderRadius:12,padding:"12px 14px",marginBottom:14}}>
                    {[["Trabajo", `${solicitudActiva?.trabajador_oficio || solicitudActiva?.oficio || "Oficio"} · ${solicitudActiva?.zona || solicitudActiva?.trabajador_zona || "Zona"}`],["Dirección", solicitudActiva?.zona || "Ver en detalle"],["Cliente", `${solicitudActiva?.cliente_nombre || "Cliente"} · ⭐ Ficio`]].map(([k,v])=>(
                      <div key={k} style={{display:"flex",gap:10,marginBottom:6}}>
                        <span style={{color:"rgba(255,255,255,0.6)",fontSize:12,minWidth:70}}>{k}</span>
                        <span style={{color:"#fff",fontSize:12,fontWeight:600}}>{v}</span>
                      </div>
                    ))}
                  </div>

                  {/* Advertencia importante */}
                  <div style={{background:"rgba(0,0,0,0.2)",borderRadius:10,padding:"10px 12px",marginBottom:14}}>
                    <div style={{color:"rgba(255,255,255,0.9)",fontSize:11,fontWeight:700,marginBottom:4}}>⚠️ Solo confirma si realmente estás trabajando con este cliente</div>
                    <div style={{color:"rgba(255,255,255,0.7)",fontSize:11,lineHeight:1.5}}>Al confirmar la obra quedas cubierto por el Fondo Ficio. Confirmar una obra falsa es causa de suspensión permanente.</div>
                  </div>

                  {/* Tiempo estimado — obligatorio */}
                  <div style={{background:"rgba(0,0,0,0.2)",borderRadius:12,padding:"14px",marginBottom:14}}>
                    <div style={{color:"#FFD54F",fontWeight:700,fontSize:13,marginBottom:4}}>⏱️ ¿Cuánto tiempo tomará la obra?</div>
                    <div style={{color:"rgba(255,255,255,0.8)",fontSize:12,marginBottom:12}}>Este tiempo define el periodo de cobertura del Fondo Ficio. <strong style={{color:"#FFD54F"}}>Obligatorio para confirmar.</strong></div>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                      {TIEMPOS.map(t=>(
                        <button key={t.val} onClick={()=>setTiempoEst(t.val)}
                          style={{background:tiempoEst===t.val?"#fff":"rgba(255,255,255,0.15)",border:`1.5px solid ${tiempoEst===t.val?"#fff":"rgba(255,255,255,0.3)"}`,borderRadius:10,padding:"8px 12px",color:tiempoEst===t.val?C.accent:"#fff",fontSize:12,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",gap:5,transition:"all 0.15s"}}>
                          <span>{t.icon}</span>{t.label}
                        </button>
                      ))}
                    </div>
                    {tiempoEst && (
                      <div style={{marginTop:10,background:"rgba(255,255,255,0.1)",borderRadius:8,padding:"8px 12px",display:"flex",gap:8,alignItems:"center"}}>
                        <span style={{fontSize:14}}>🛡️</span>
                        <span style={{color:"rgba(255,255,255,0.9)",fontSize:12}}>Cobertura activa por <strong>{TIEMPOS.find(t=>t.val===tiempoEst)?.cobertura}</strong>. Si la obra se extiende el cliente debe solicitar prórroga aprobada por Ficio.</span>
                      </div>
                    )}
                  </div>

                  <div style={{display:"flex",gap:10}}>
                    <button onClick={async ()=>{
                      await actualizarStatusSolicitud("cancelada", { trabajador_concluyo: false });
                      setObraStatus("sin_solicitud");
                    }} style={{flex:1,background:"rgba(255,255,255,0.15)",border:"1.5px solid rgba(255,255,255,0.3)",borderRadius:12,padding:"12px",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>✗ Rechazar</button>
                    <button onClick={async ()=>{
                      if(!tiempoEst) return;
                      await actualizarStatusSolicitud("aceptada", { trabajador_concluyo: false, started_at: new Date().toISOString() });
                      setObraStatus("confirmada_trabajador");
                    }} style={{flex:1,background:"#fff",border:"none",borderRadius:12,padding:"12px",color:tiempoEst?C.accent:"#CCC",fontSize:13,fontWeight:700,cursor:tiempoEst?"pointer":"not-allowed"}}>✓ Confirmar obra</button>
                  </div>
                  {!tiempoEst&&<div style={{color:"rgba(255,255,255,0.7)",fontSize:11,textAlign:"center",marginTop:8}}>Debes declarar el tiempo estimado antes de confirmar</div>}
                </div>

                {/* Tiempo restante */}
                <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,padding:"12px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{color:C.muted,fontSize:12}}>Tiempo para responder</span>
                  <span style={{color:countdown==="Expirada"?C.red:C.accent,fontSize:13,fontWeight:700}}>{countdown || "Calculando..."}</span>
                </div>
              </div>
            )}

            {/* TRABAJADOR CONFIRMÓ — esperando al cliente */}
            {obraStatus==="confirmada_trabajador" && (
              <div>
                <div style={{background:C.blueL,border:`1.5px solid ${C.blue}30`,borderRadius:14,padding:16,marginBottom:14}}>
                  <div style={{color:C.blue,fontWeight:700,fontSize:14,marginBottom:4}}>✓ Confirmaste la obra</div>
                  <div style={{color:C.sub,fontSize:12}}>Esperando que el cliente active la cobertura. Cuando lo haga el Fondo Ficio quedará activo.</div>
                </div>

                {/* Geolocalización opcional */}
                <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:14,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
                  <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                    <span style={{fontSize:22,flexShrink:0}}>📍</span>
                    <div style={{flex:1}}>
                      <div style={{fontFamily:"'Georgia',serif",fontSize:15,fontWeight:800,color:C.text,marginBottom:3}}>Compartir ubicación</div>
                      <div style={{color:C.sub,fontSize:12,lineHeight:1.5,marginBottom:12}}>Opcional pero recomendado. Tu ubicación queda registrada como respaldo en caso de siniestro. <strong style={{color:C.text}}>No se comparte con el cliente.</strong></div>

                      {!geoShared ? (
                        <div>
                          <Btn full color={C.green} onClick={simularGeo}>
                            {geoLoading ? "📡 Obteniendo ubicación..." : "📍 Compartir mi ubicación ahora"}
                          </Btn>
                          <button onClick={()=>setGeoShared("omitida")} style={{width:"100%",background:"none",border:"none",color:C.muted,fontSize:11,marginTop:8,cursor:"pointer",textDecoration:"underline"}}>Omitir por ahora</button>
                        </div>
                      ) : geoShared==="omitida" ? (
                        <div style={{background:"#FFFDE7",border:`1px solid #F9A82540`,borderRadius:10,padding:"10px 12px"}}>
                          <div style={{color:"#795548",fontSize:12}}>⚠️ Sin ubicación registrada. En caso de accidente necesitarás documentación adicional para el Fondo Ficio.</div>
                        </div>
                      ) : (
                        <div style={{background:C.greenL,border:`1.5px solid ${C.green}30`,borderRadius:10,padding:"10px 14px",display:"flex",gap:8,alignItems:"center"}}>
                          <span style={{fontSize:18}}>✅</span>
                          <div>
                            <div style={{color:C.green,fontWeight:700,fontSize:12}}>Ubicación registrada</div>
                            <div style={{color:C.sub,fontSize:11}}>Ubicación GPS registrada · {new Date().toLocaleTimeString("es-MX",{hour:"2-digit",minute:"2-digit"})}</div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div style={{background:C.accentL,border:`1.5px solid ${C.accent}25`,borderRadius:12,padding:"10px 14px"}}>
                  <div style={{color:C.accent,fontSize:12,fontWeight:600}}>💡 La cobertura inicia cuando el cliente también confirme. Si no confirma en 24 horas la solicitud expira.</div>
                </div>
              </div>
            )}

            {/* OBRA ACTIVA — trabajador */}
            {obraStatus==="activa" && (
              <div>
                <div style={{background:C.greenL,border:`1.5px solid ${C.green}30`,borderRadius:12,padding:"14px 16px",marginBottom:14}}>
                  <div style={{color:C.green,fontWeight:700,fontSize:13,marginBottom:4}}>🛡️ Estás cubierto</div>
                  <div style={{color:C.sub,fontSize:12}}>El Fondo Ficio te da un apoyo de emergencia de hasta $5,000 ante accidentes físicos en obra. L-S 7am–6pm.</div>
                </div>

                {/* Geo badge si compartió */}
                {geoShared===true && (
                  <div style={{background:C.blueL,border:`1px solid ${C.blue}25`,borderRadius:10,padding:"10px 14px",marginBottom:14,display:"flex",gap:8,alignItems:"center"}}>
                    <span style={{fontSize:14}}>📍</span>
                    <span style={{color:C.blue,fontSize:12,fontWeight:600}}>Ubicación registrada como respaldo ante siniestro</span>
                  </div>
                )}
                {geoShared==="omitida" && (
                  <div style={{background:"#FFFDE7",border:`1px solid #F9A82540`,borderRadius:10,padding:"10px 14px",marginBottom:14,display:"flex",gap:8,alignItems:"center"}}>
                    <span style={{fontSize:14}}>⚠️</span>
                    <span style={{color:"#795548",fontSize:12}}>Sin ubicación — documenta bien si ocurre un accidente</span>
                  </div>
                )}

                <div style={{background:C.accentL,border:`1.5px solid ${C.accent}25`,borderRadius:14,padding:16,marginBottom:14,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
                  <div style={{color:C.accent,fontWeight:700,fontSize:13,marginBottom:4}}>🦺 ¿Necesitas ayudantes para esta obra?</div>
                  <div style={{color:C.sub,fontSize:12,marginBottom:12}}>Conecta con ayudantes verificados en tu zona. Todos tienen INE validado y reputación real en Ficio. <strong style={{color:C.accent}}>$50 pesos</strong> por conexión confirmada.</div>
                  <Btn full color={C.accent} onClick={()=>setScreen("buscar-ayudante")}>🦺 Buscar ayudante verificado →</Btn>
                </div>

                <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:14,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
                  <div style={{color:C.text,fontWeight:700,fontSize:13,marginBottom:4}}>¿El trabajo terminó pero el cliente no cierra?</div>
                  <div style={{color:C.muted,fontSize:12,marginBottom:12}}>Solicita un supervisor de Ficio para mediar la situación. El costo es la visita estándar de supervisión: <strong style={{color:C.accent}}>$499 pesos</strong>. El supervisor visita la obra y emite resolución en 48 horas.</div>
                  <Btn full color={C.blue} onClick={()=>setShowDisputa(true)}>⚖️ Solicitar mediador</Btn>
                </div>

                <div style={{background:C.redL,border:`1.5px solid ${C.red}30`,borderRadius:12,padding:"14px 16px"}}>
                  <div style={{color:C.red,fontWeight:700,fontSize:13,marginBottom:4}}>🚨 ¿Ocurrió un accidente?</div>
                  <div style={{color:C.sub,fontSize:12,marginBottom:10}}>Repórtalo en las primeras 48 horas con foto + ticket médico + reporte del cliente.</div>
                  <Btn full color={C.red} onClick={async()=>{
                    if(!solicitudActiva?.id){window.ficioToast?.("No hay obra activa registrada", "warn");return;}
                    // Usar toast de confirmación en lugar de window.confirm
                    // accidente confirmado por el usuario al presionar el botón
                    await supabase.from("solicitudes").update({
                      accidente_reportado:true,
                      accidente_reportado_at:new Date().toISOString(),
                      status:"accidente_reportado",
                      updated_at:new Date().toISOString()
                    }).eq("id",solicitudActiva.id);
                    setObraStatus("disputa");
                    window.ficioToast?.("Accidente reportado. Ficio lo revisará en máximo 48 horas.", "success", 5000);
                  }}>Reportar accidente ahora</Btn>
                </div>
              </div>
            )}

            {obraStatus==="disputa"&&<div style={{background:C.blueL,border:`1.5px solid ${C.blue}30`,borderRadius:12,padding:"14px 16px"}}><div style={{color:C.blue,fontWeight:700,fontSize:13,marginBottom:4}}>⚖️ Mediación en proceso</div><div style={{color:C.sub,fontSize:12}}>Resolución en máximo 48 horas.</div></div>}
            {obraStatus==="cerrada"&&<div style={{background:C.greenL,border:`1.5px solid ${C.green}30`,borderRadius:12,padding:"14px 16px"}}><div style={{color:C.green,fontWeight:700,fontSize:13,marginBottom:4}}>✅ Obra cerrada</div><div style={{color:C.sub,fontSize:12}}>Ya puedes calificar a este cliente.</div></div>}
          </div>
        )}
      </div>

      {/* Modal prórroga */}
      {showProrroga && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:200,display:"flex",alignItems:"flex-end",justifyContent:"center",padding:20}}>
          <div style={{background:C.surface,borderRadius:20,maxWidth:480,width:"100%",padding:24,boxShadow:"0 -8px 32px rgba(0,0,0,0.15)"}}>
            <div style={{fontFamily:"'Georgia',serif",fontSize:20,fontWeight:800,color:C.text,marginBottom:4}}>Solicitar prórroga de cobertura</div>
            <div style={{color:C.muted,fontSize:13,lineHeight:1.6,marginBottom:16}}>La prórroga extiende el periodo de cobertura del Fondo Ficio. Requiere aprobación del administrador de Ficio.</div>
            <div style={{background:"#FFFDE7",border:`1px solid #F9A82540`,borderRadius:12,padding:"12px 14px",marginBottom:16}}>
              {[["Tiempo original",TIEMPOS.find(t=>t.val===tiempoEst)?.label||"—"],["Aprobación","El administrador de Ficio la revisa en 24 horas"],["Costo","Sin costo adicional — solo aplica una vez"],["Si se rechaza","La cobertura termina al vencer el tiempo original"]].map(([k,v])=>(
                <div key={k} style={{display:"flex",justifyContent:"space-between",marginBottom:5}}>
                  <span style={{color:C.muted,fontSize:12}}>{k}</span>
                  <span style={{color:"#795548",fontSize:12,fontWeight:700}}>{v}</span>
                </div>
              ))}
            </div>
            <div style={{background:C.blueL,border:`1px solid ${C.blue}25`,borderRadius:12,padding:"10px 14px",marginBottom:16}}>
              <div style={{color:C.blue,fontSize:12,fontWeight:600,marginBottom:2}}>📋 Motivo de la prórroga</div>
              <textarea value={prorrogaMotivo} onChange={e=>setProrrogaMotivo(e.target.value)} placeholder="Explica brevemente por qué necesitas más tiempo..." rows={3}
                style={{width:"100%",background:"transparent",border:"none",color:C.text,fontSize:12,resize:"none",outline:"none",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",lineHeight:1.5,boxSizing:"border-box",marginTop:4}}/>
            </div>
            <div style={{display:"flex",gap:10}}>
              <Btn full outline color={C.muted} onClick={()=>{setShowProrroga(false);setProrrogaMotivo("");}}>Cancelar</Btn>
              <Btn full color={C.blue} onClick={async()=>{
                if(!prorrogaMotivo.trim()){window.ficioToast?.("Escribe el motivo de la prórroga", "warn"); return;}
                if(solicitudActiva?.id){
                  await supabase.from("solicitudes").update({
                    prorroga_solicitada:true,
                    prorroga_motivo:prorrogaMotivo.trim(),
                    prorroga_solicitada_at:new Date().toISOString(),
                    updated_at:new Date().toISOString()
                  }).eq("id",solicitudActiva.id);
                }
                setShowProrroga(false);
                setProrrogaMotivo("");
                window.ficioToast?.("Prórroga enviada. Te avisamos en máximo 24 horas.", "success");
              }}>Enviar solicitud a Ficio</Btn>
            </div>
            <div style={{color:C.muted,fontSize:11,textAlign:"center",marginTop:10}}>Recibirás respuesta por WhatsApp en máximo 24 horas</div>
          </div>
        </div>
      )}

      {/* Modal mediación */}
      {showDisputa && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:200,display:"flex",alignItems:"flex-end",justifyContent:"center",padding:20}}>
          <div style={{background:C.surface,borderRadius:20,maxWidth:480,width:"100%",padding:24,boxShadow:"0 -8px 32px rgba(0,0,0,0.15)"}}>
            <div style={{fontFamily:"'Georgia',serif",fontSize:20,fontWeight:800,color:C.text,marginBottom:4}}>Solicitar supervisor mediador</div>
            <div style={{color:C.muted,fontSize:13,lineHeight:1.6,marginBottom:14}}>Un supervisor verificado de Ficio visitará la obra y emitirá resolución oficial en 48 horas con reporte firmado por ambas partes.</div>

            {/* Supervisor asignado */}
            <div style={{background:C.blueL,border:`1.5px solid ${C.blue}25`,borderRadius:14,padding:14,marginBottom:14,display:"flex",gap:12,alignItems:"center"}}>
              <div style={{width:44,height:44,borderRadius:12,background:`linear-gradient(135deg,${C.blue},#0C447C)`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>🏗️</div>
              <div style={{flex:1}}>
                <div style={{color:C.sub,fontSize:10,fontWeight:700,letterSpacing:1,textTransform:"uppercase",marginBottom:2}}>Supervisor asignado por Ficio</div>
                <div style={{fontFamily:"'Georgia',serif",fontSize:15,fontWeight:800,color:C.text}}>Supervisor Ficio</div>
                <div style={{color:C.blue,fontSize:12}}>Cédula SEP verificada · Ficio lo asigna en 24h</div>
              </div>
              <Chip text="Disponible" color={C.green} small/>
            </div>

            {/* Desglose de costos */}
            <div style={{background:C.bg,borderRadius:12,padding:"12px 14px",marginBottom:14}}>
              {[
                ["Costo visita supervisor","$499 pesos"],
                ["Va al supervisor","$349 pesos"],
                ["Retención Ficio","$150 pesos"],
                ["¿Quién paga?","El trabajador solicitante"],
                ["Resolución","48 horas tras la visita"],
                ["Si te favorece","Obra cerrada + penalización al cliente"],
                ["Si no te favorece","El costo corre por tu cuenta"],
              ].map(([k,v])=>(
                <div key={k} style={{display:"flex",justifyContent:"space-between",marginBottom:6,paddingBottom:6,borderBottom:`1px solid ${C.divider}`}}>
                  <span style={{color:C.muted,fontSize:12}}>{k}</span>
                  <span style={{color:C.blue,fontSize:12,fontWeight:700}}>{v}</span>
                </div>
              ))}
            </div>

            <div style={{background:"#FFFDE7",border:`1px solid #F9A82540`,borderRadius:10,padding:"10px 14px",marginBottom:14}}>
              <div style={{color:"#795548",fontSize:12,lineHeight:1.5}}>⚠️ La resolución del supervisor es definitiva y no apelable. Ambas partes deben firmar el reporte dentro de Ficio.</div>
            </div>

            <div style={{display:"flex",gap:10}}>
              <Btn full outline color={C.muted} onClick={()=>setShowDisputa(false)}>Cancelar</Btn>
              <Btn full color={C.blue} onClick={async()=>{
                await actualizarStatusSolicitud("mediacion_solicitada",{
                  mediation_requested_by:role,
                  mediation_fee:500,
                  mediation_reason:"Solicitado desde Mi Obra",
                  mediation_requested_at:new Date().toISOString()
                });
                setObraStatus("disputa");
                setShowDisputa(false);
              }}>Confirmar — $499 pesos</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


